import BasePage from "./BasePage";
import LegacyFormHelper from "@Scripts/Infrastructure/LegacyFormHelper";

export default class TestRideModifyPage extends BasePage {
    private static isProfiling: boolean = false;
    private static isMarketing: boolean = false;
    private static marketingChannels: any[] = [];

    public static async init() {
        await super.init();

        this.setForm();
        this.setDemoProductBox();
        this.setPersonalDataBox();
        this.showParentBox();
        this.setParentPersonalDataBox();
        this.setParent2PersonalDataBox();
        this.setEmailBox();
        this.setDriverLicence();
        this.setAddressBox();

        $("#DemoProductFrame").on("change", function () {
            TestRideModifyPage.setDemoProductBox();

            (<any>window).App.TestRideService.getEventSlots({ demoProductFrame: $("#DemoProductFrame").val(), eventIdMaster: (<any>window).App.bag.eventIdMaster, testRideId: (<any>window).App.bag.testRideId }).then(function (data) {
                var dropdown = $("#EventSlotId");
                dropdown.empty();
                dropdown.append($("<option />").val("").text("..."));
                $.each(data, function () {
                    dropdown.append($("<option />").val(this.Value).text(this.Title));
                });
            });
        });

        $("#IsPassenger").on("change", function () {
            $("#DriverLicenseNumber").val("");
            $("#DriverLicenseExpirationDate").val("");
            $("#DriverDriverLicenseNumber").val("");
            TestRideModifyPage.setDriverLicence();
        });

        $("#BirthDate").on("change", function () {
            TestRideModifyPage.showParentBox();
        });

        $("#Region").on("change", function () {
            $("#Zone").val("");
            $("#Location").val("");

            (<any>window).App.ProfileService.getProvinces({ region: $("#Region").val() }).then(function (data) {
                var dropdown = $("#Zone");
                dropdown.empty();
                dropdown.append($("<option />").val("").text("..."));
                $.each(data, function () {
                    dropdown.append($("<option />").val(this.Value).text(this.Title));
                });
            });
        });

        $("#Country").on("change", function () {
            TestRideModifyPage.setAddressBox();
        });

        let self = this;

        document.addEventListener("privacy", function (event: any) {
            switch (event.detail?.type) {
                case "profiling":
                    self.isProfiling = event.detail.isProfiling;
                    break;
                case "marketing":
                    self.isMarketing = event.detail.isMarketing;
                    break;
                case "marketingChannels":
                    self.marketingChannels = event.detail.marketingChannels;
                    break;
            }
        });
    }

    private static setForm() {
        let vm = this;

        var $form = $("#FormTestRideModify"),
            $successBox = $(".success-box"),
            $formIntro = $(".form-introduction"),
            $disableOnSubmit = $(".disable-on-submit", $form);

        (<any>$form).ajaxForm({
            iframe: false,
            dataType: "json",
            beforeSubmit: function (formData, jqForm, options) {
                $disableOnSubmit.attr("disabled", "disabled");
                LegacyFormHelper.resetValidation($form);

                if (formData.findIndex(x => x.name === "IsProfiling") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsProfiling"), 1);
                }
                if (formData.findIndex(x => x.name === "IsMarketing") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsMarketing"), 1);
                }
                if (formData.findIndex(x => x.name === "IsMarketingEmail") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsMarketingEmail"), 1);
                }
                if (formData.findIndex(x => x.name === "IsMarketingPhone") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsMarketingPhone"), 1);
                }
                if (formData.findIndex(x => x.name === "IsMarketingMail") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsMarketingMail"), 1);
                }

                formData.push({ name: "IsProfiling", value: vm.isProfiling, type: "checkbox", required: false });
                formData.push({ name: "IsMarketing", value: vm.isMarketing, type: "checkbox", required: false });
                formData.push({ name: "MarketingChannels", value: vm.marketingChannels, type: "checkbox", required: false });
            },
            success: function (data) {
                LegacyFormHelper.resetValidation($form);

                if (data.saveMode) {
                    if (data.saveMode === "Execute") {
                        window.location.href = (<any>window).App.routes.TestRideEvent_TestRide_LiabilityDischarge + "?testRideId=" + data.testRideId;
                    } else {
                        (<any>$form).hide();
                        $formIntro.hide();
                        $successBox.show();
                    }
                } else {
                    $disableOnSubmit.removeAttr("disabled");
                    LegacyFormHelper.setValidation($form, data.State);
                }
            },
            error: function (xhr, textStatus, errorThrown) {
                LegacyFormHelper.enableControls($form);
                LegacyFormHelper.setValidation($form, xhr.responseJSON);
            }
        });
    }

    private static setDemoProductBox() {
        var $form = $("#FormTestRideModify");

        if ($("#DemoProductFrame", $form).val()) {
            $(".product-description-intro").hide();
            $(".product-description").hide();
            $(".product-description[data-product='" + $("#DemoProductFrame", $form).val() + "']").show();
        } else {
            $(".product-description-intro").show();
            $(".product-description").hide();
        }
    }

    private static setPersonalDataBox() {
        var $form = $("#FormTestRideModify");

        setBirthLocation();

        $("#BirthCountry", $form).on("change", function () { setBirthLocation(); });
        $("#ButtonTaxCode", $form).on("click tap touchstart", function () { calculateTaxCode(); });

        function setBirthLocation() {
            if ($("#BirthCountry", $form).val() === "ITALIA") {
                $("#BirthLocationRow", $form).show();
            } else {
                $("#BirthLocationRow", $form).hide();
            }
        }

        function calculateTaxCode() {
            var $name = $("#Name", $form).val(),
                $surname = $("#Surname", $form).val(),
                $birthDate = $("#BirthDate", $form).val(),
                $birthLocation = $("#BirthLocation", $form).val(),
                $birthCountry = $("#BirthCountry", $form).val(),
                $gender = $("input[name='Gender']:checked", $form).val();

            (<any>window).App.instances.vm.$store.dispatch("profileStore/getTaxCode", {
                name: $name,
                surname: $surname,
                birthDate: $birthDate,
                birthLocation: $birthLocation,
                birthCountry: $birthCountry,
                gender: $gender,
                __RequestVerificationToken: TestRideModifyPage.getAntiForgeryToken()
            }).then((data) => {
                if (data.success) {
                    LegacyFormHelper.resetValidation($form);
                    $("#TaxCode", $form).val(data.taxCode);
                } else {
                    LegacyFormHelper.setValidation($form, data.state);
                }
            });
        }
    }

    private static setAddressBox() {
        if ($("#Country").val() === "Italy") {
            $("#RegionRow").show();
            $("#ZoneRow").show();
        } else {
            $("#RegionRow").hide();
            $("#ZoneRow").hide();
            $("#Region").val("");
            $("#Zone").val("");
        }
    }

    private static showParentBox() {
        if ($("#BirthDate").val()) {
            var today = new Date();
            var birthDate = new Date(<any>$("#BirthDate").val());
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();

            if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
                age--;
            }

            if (age < 18) {
                $("#DriverLicenseBox").hide();
                $("#DriverLicenseNumber").val("");
                $("#DriverLicenseExpirationDate").val("");

                $("#ParentPersonalDataBox").show();
                $("#ParentResidenceDataBox").show();

                this.setParentPersonalDataBox();
                this.setParentAddressBox();

                $("#ParentRegion").change(function () {
                    $("#ParentZone").val("");
                    $("#ParentLocation").val("");

                    (<any>window).App.ProfileService.getProvinces({ region: $("#ParentRegion").val() }).then(function (data) {
                        var dropdown = $("#ParentZone");
                        dropdown.empty();
                        dropdown.append($("<option />").val("").text("..."));
                        $.each(data, function () {
                            dropdown.append($("<option />").val(this.Value).text(this.Title));
                        });
                    });
                });

                $("#ParentCountry").on("change", function () {
                    TestRideModifyPage.setParentAddressBox();
                });

                $("#Parent2PersonalDataBox").show();
                $("#Parent2ResidenceDataBox").show();

                this.setParent2PersonalDataBox();
                this.setParent2AddressBox();

                $("#Parent2Region").on("change", function () {
                    $("#Parent2Zone").val("");
                    $("#Parent2Location").val("");

                    (<any>window).App.ProfileService.getProvinces({ region: $("#Parent2Region").val() }).then(function (data) {
                        var dropdown = $("#Parent2Zone");
                        dropdown.empty();
                        dropdown.append($("<option />").val("").text("..."));
                        $.each(data, function () {
                            dropdown.append($("<option />").val(this.Value).text(this.Title));
                        });
                    });
                });

                $("#Parent2Country").on("change", function () {
                    TestRideModifyPage.setParent2AddressBox();
                });
            } else {
                $("#DriverLicenseBox").show();

                $("#ParentName").val("");
                $("#ParentSurname").val("");
                $("#ParentBirthDate").val("");
                $("#ParentBirthCountry").val("");
                $("#ParentBirthLocation").val("");
                $("#ParentGender").val("");
                $("#ParentTaxCode").val("");
                $("#ParentCountry").val("");
                $("#ParentRegion").val("");
                $("#ParentZone").val("");
                $("#ParentLocation").val("");
                $("#ParentPostCode").val("");
                $("#ParentAddressType").val("");
                $("#ParentAddress").val("");
                $("#ParentAddressNumber").val("");
                $("#ParentPhone").val("");
                $("#ParentEmail").val("");
                $("#ParentPersonalDataBox").hide();
                $("#ParentResidenceDataBox").hide();

                $("#Parent2Name").val("");
                $("#Parent2Surname").val("");
                $("#Parent2BirthDate").val("");
                $("#Parent2BirthCountry").val("");
                $("#Parent2BirthLocation").val("");
                $("#Parent2Gender").val("");
                $("#Parent2TaxCode").val("");
                $("#Parent2Country").val("");
                $("#Parent2Region").val("");
                $("#Parent2Zone").val("");
                $("#Parent2Location").val("");
                $("#Parent2PostCode").val("");
                $("#Parent2AddressType").val("");
                $("#Parent2Address").val("");
                $("#Parent2AddressNumber").val("");
                $("#Parent2Phone").val("");
                $("#Parent2Email").val("");
                $("#Parent2PersonalDataBox").hide();
                $("#Parent2ResidenceDataBox").hide();
            }
        }
    }

    private static setParentPersonalDataBox() {
        var $form = $("#FormTestRideModify");

        setBirthLocation();

        $("#ParentBirthCountry", $form).on("change", function () { setBirthLocation(); });
        $("#ParentButtonTaxCode", $form).on("click tap touchstart", function () { calculateTaxCode(); });

        function setBirthLocation() {
            if ($("#ParentBirthCountry", $form).val() === "ITALIA") {
                $("#ParentBirthLocationRow", $form).show();
            } else {
                $("#ParentBirthLocationRow", $form).hide();
            }
        }

        function calculateTaxCode() {
            var $name = $("#ParentName", $form).val(),
                $surname = $("#ParentSurname", $form).val(),
                $birthDate = $("#ParentBirthDate", $form).val(),
                $birthLocation = $("#ParentBirthLocation", $form).val(),
                $birthCountry = $("#ParentBirthCountry", $form).val(),
                $gender = $("input[name='ParentGender']:checked", $form).val();

            (<any>window).App.instances.vm.$store.dispatch("profileStore/getParentTaxCode", {
                parentname: $name,
                parentsurname: $surname,
                parentbirthDate: $birthDate,
                parentbirthLocation: $birthLocation,
                parentbirthCountry: $birthCountry,
                parentgender: $gender,
                __RequestVerificationToken: TestRideModifyPage.getAntiForgeryToken()
            }).then((data) => {
                if (data.data) {
                    LegacyFormHelper.resetValidation($form);
                    $("#ParentTaxCode", $form).val(data.data.taxCode);
                } else {
                    LegacyFormHelper.setValidation($form, data);
                }
            });
        }
    }

    private static setParent2PersonalDataBox() {
        var $form = $("#FormTestRideModify");

        setBirthLocation();

        $("#Parent2BirthCountry", $form).on("change", function () { setBirthLocation(); });
        $("#Parent2ButtonTaxCode", $form).on("click tap touchstart", function () { calculateTaxCode(); });

        function setBirthLocation() {
            if ($("#Parent2BirthCountry", $form).val() === "ITALIA") {
                $("#Parent2BirthLocationRow", $form).show();
            } else {
                $("#Parent2BirthLocationRow", $form).hide();
            }
        }

        function calculateTaxCode() {
            var $name = $("#Parent2Name", $form).val(),
                $surname = $("#Parent2Surname", $form).val(),
                $birthDate = $("#Parent2BirthDate", $form).val(),
                $birthLocation = $("#Parent2BirthLocation", $form).val(),
                $birthCountry = $("#Parent2BirthCountry", $form).val(),
                $gender = $("input[name='Parent2Gender']:checked", $form).val();

            (<any>window).App.instances.vm.$store.dispatch("profileStore/getParent2TaxCode", {
                parent2name: $name,
                parent2surname: $surname,
                parent2birthDate: $birthDate,
                parent2birthLocation: $birthLocation,
                parent2birthCountry: $birthCountry,
                parent2gender: $gender,
                __RequestVerificationToken: TestRideModifyPage.getAntiForgeryToken()
            }).then((data) => {
                if (data.data) {
                    LegacyFormHelper.resetValidation($form);
                    $("#Parent2TaxCode", $form).val(data.data.taxCode);
                } else {
                    LegacyFormHelper.setValidation($form, data);
                }
            });
        }
    }

    private static setParentAddressBox() {
        if ($("#ParentCountry").val() === "Italy") {
            $("#ParentRegionRow").show();
            $("#ParentZoneRow").show();
        } else {
            $("#ParentRegionRow").hide();
            $("#ParentZoneRow").hide();
            $("#ParentRegion").val("");
            $("#ParentZone").val("");
        }
    }

    private static setParent2AddressBox() {
        if ($("#Parent2Country").val() === "Italy") {
            $("#Parent2RegionRow").show();
            $("#Parent2ZoneRow").show();
        } else {
            $("#Parent2RegionRow").hide();
            $("#Parent2ZoneRow").hide();
            $("#Parent2Region").val("");
            $("#Parent2Zone").val("");
        }
    }

    private static setEmailBox() {
        var $form = $("#FormTestRideModify");

        setEmailVisible();

        $("#IsEmailNotAvailable", $form).on("change", function () { setEmailVisible(); });

        function setEmailVisible() {
            if ((<any>$("#IsEmailNotAvailable", $form)[0]).checked) {
                $("#Email", $form).val("");
                $("#EmailConfirm", $form).val("");
            }
        }
    }

    private static setDriverLicence() {
        if ($("input[name='IsPassenger']").is(":checked")) {
            $("#PassengerBox").show();
            $("#DriverBox").hide();
        } else {
            $("#PassengerBox").hide();
            $("#DriverBox").show();
        }
    }

    private static getAntiForgeryToken() {
        var $context = $("#Page");
        return $("input[name=__RequestVerificationToken]", $context).val();
    }
}